
<div [formGroup]="contactpersonFormGroup" class="form flex flex-col">
  <nx-edit-text-input  *ngIf="!isName"
    formControlName="firstName"
    [placeholder]="'rentModule.contactPersonDialogComponent.fields.firstName.placeholder' | translate"
    [label]="'rentModule.contactPersonDialogComponent.fields.firstName.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input  *ngIf="!isName"
    formControlName="lastName"
    [placeholder]="'rentModule.contactPersonDialogComponent.fields.lastName.placeholder' | translate"
    [label]="'rentModule.contactPersonDialogComponent.fields.lastName.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input  *ngIf="isName"
    formControlName="name"
    [placeholder]="'rentModule.contactPersonDialogComponent.fields.name.placeholder' | translate"
    [label]="'rentModule.contactPersonDialogComponent.fields.name.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="phoneNumber"
    [placeholder]="'rentModule.contactPersonDialogComponent.fields.phone.placeholder' | translate"
    [label]="'rentModule.contactPersonDialogComponent.fields.phone.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="mobileNumber"
    [placeholder]="'rentModule.contactPersonDialogComponent.fields.mobile.placeholder' | translate"
    [label]="'rentModule.contactPersonDialogComponent.fields.mobile.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="email"
    [placeholder]="'rentModule.contactPersonDialogComponent.fields.email.placeholder' | translate"
    [label]="'rentModule.contactPersonDialogComponent.fields.email.label' | translate">
  </nx-edit-text-input>
<div>
